export default `
  *, *:before, *:after {
    box-sizing: border-box;
    outline: none;
  }

  ul {
    margin: 0;
    padding: 0;
  }

  li {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  table {
    padding:0;
    margin:0;
    border-spacing: 0;
    border-collapse: collapse;
  }

  td {
    padding:0;
    margin:0;
  }
`;
